import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    itemName: String,
    itemId: Number,
    aiEnabled: Boolean,
    reviewComment: String
  }

  connect() {
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  handleSubmitEnd(event) {
    if (!event.detail.success) return
    if (!this.aiEnabledValue) return

    // テキストエリアからコメントを取得（送信前の値はvalueに残っている場合がある）
    const textarea = this.element.querySelector("textarea")
    const comment = textarea ? textarea.value.trim() : ""

    // item-modalを閉じる
    const itemModal = this.application.getControllerForElementAndIdentifier(
      document.querySelector("[data-controller~='item-modal']"),
      "item-modal"
    )
    if (itemModal) itemModal.close()

    // ai-chatをレビューコンテキスト付きで開く
    setTimeout(() => {
      const aiChat = this.application.getControllerForElementAndIdentifier(
        document.querySelector("[data-controller~='ai-chat']"),
        "ai-chat"
      )
      if (aiChat) {
        aiChat.openWithReviewContext(this.itemNameValue, comment, this.itemIdValue)
      }
    }, 300)
  }
}
